import { render } from "./OcrImage.vue?vue&type=template&id=4821e036&scoped=true"
import script from "./OcrImage.vue?vue&type=script&lang=js"
export * from "./OcrImage.vue?vue&type=script&lang=js"

import "./OcrImage.vue?vue&type=style&index=0&id=4821e036&scoped=true&lang=css"

import exportComponent from "/home/kuradmin/dev-frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4821e036"]])

export default __exports__